import { render, staticRenderFns } from "./PositionDesktopRelate.vue?vue&type=template&id=7d6fb3f2"
import script from "./PositionDesktopRelate.vue?vue&type=script&lang=js"
export * from "./PositionDesktopRelate.vue?vue&type=script&lang=js"
import style0 from "./PositionDesktopRelate.vue?vue&type=style&index=0&id=7d6fb3f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports